var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut-chart"},[(_vm.percent < 100)?_c('DoughnutChart',{attrs:{"outerRadius":100,"innerRadius":88,"percentage":_vm.progress}}):_c('DoughnutChartGradient',{attrs:{"outerRadius":100,"innerRadius":88,"backgroundColor":'lightgray',"innerBackgroundColor":'white',"percentage":_vm.progress,"strokeWidth":11}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }